import { render, staticRenderFns } from "./PoiMarker.vue?vue&type=template&id=eff0cd96&scoped=true"
import script from "./PoiMarker.vue?vue&type=script&lang=js"
export * from "./PoiMarker.vue?vue&type=script&lang=js"
import style0 from "./PoiMarker.vue?vue&type=style&index=0&id=eff0cd96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff0cd96",
  null
  
)

export default component.exports